import { WORKOUT_CLASS_NAME } from '../../../workout/model/constants'
import { PLAN_CLASS_NAME } from '../../../plan/model/constants'

const POST_KEY = {
  ID: 'id',
  CREATED_AT: 'createdAt',
  UPDATED_AT: 'updatedAt',
  CLASS_NAME: 'className',

  DESCRIPTION: 'description',
  IMAGE: 'image',
  URL: 'url',
  TITLE: 'title',
  TYPE: 'type',
  PUBLISHED_AT: 'publishedAt',

  // Associations
  MEDIA: 'media',
  ATTACHMENT: 'attachment',
  TAGS: 'tags',

  // Foreign Keys
  MEDIA_ID: 'mediaId',
  ATTACHMENT_ID: 'attachmentId',
  PROFILE_ID: 'profileId',

  // Virtual
  PROFILE: 'profile',
  POST_PROFILE: 'postProfile'
}

const POST_PRIVATE_KEYS = []

const POST_FOREIGN_KEYS = [
  POST_KEY.ATTACHMENT_ID,
  POST_KEY.PROFILE_ID
]

export {
  POST_PRIVATE_KEYS,
  POST_KEY,
  POST_FOREIGN_KEYS
}

const POST_CLASS_NAME = 'Post'

export { POST_CLASS_NAME }
const POST_AUDIT = {
  CREATED: 'Post Created',
  DELETED: 'Post Deleted',
  UPDATED: 'Post Updated'
}

export { POST_AUDIT }

const POST_SCOPE = {

  /**
   * Only returns the public attributes of the Post.
   * @type {Object}
   */
  defaultScope: {
    attributes: {
      exclude: POST_PRIVATE_KEYS
    }
  }

}

export { POST_SCOPE }
const POST_TYPE = {
  ARTICLE: 1,
  QUOTE: 2,
  WORKOUT_STARTED: 1000,
  WORKOUT_LOGGED: 1001,
  PLAN_STARTED: 2000,
  PLAN_LOGGED: 2001
}

export const POST_TYPES_RECOMMENDED = [
  POST_TYPE.ARTICLE
]

const POST_TYPES_ADMIN = [
  POST_TYPE.ARTICLE
]

export {
  POST_TYPE,
  POST_TYPES_ADMIN
}

const POST_TYPE_TO_ATTACHMENT_CLASS_NAME = {
  [POST_TYPE.WORKOUT_STARTED]: WORKOUT_CLASS_NAME,
  [POST_TYPE.WORKOUT_LOGGED]: WORKOUT_CLASS_NAME,
  [POST_TYPE.PLAN_STARTED]: PLAN_CLASS_NAME,
  [POST_TYPE.PLAN_LOGGED]: PLAN_CLASS_NAME
}

export { POST_TYPE_TO_ATTACHMENT_CLASS_NAME }

export const POST_ASSOCIATIONS = [
  POST_KEY.ATTACHMENT,
  POST_KEY.MEDIA,
  POST_KEY.TAGS
]

export const POST_TYPES_WITHOUT_ATTACHMENT = [
  POST_TYPE.ARTICLE
]
